import { Button, Result } from 'antd';
import React from 'react';
import { logout } from '~/utils/auth';

const NoRestaurant = () => {
  const onClick = () => {
    logout();
  };

  return (
    <div className="h-screen w-screen flex items-center justify-center fixed">
      <Result
        status="error"
        title="Tidak ada akses restoran"
        subTitle="Harap minta admin untuk memberikan akses restoran"
        extra={[
          <Button type="primary" onClick={onClick}>
            Logout
          </Button>,
        ]}
      />
    </div>
  );
};

export default NoRestaurant;
